import type { WebSocketSessionInfo } from './webSocketService';
import type { AppDispatch } from '../../data/store';
import type { TripLegPackageDetail } from '../../data/models/trip-leg.model';
import * as tripPackageInventorySlice from '../../data/tripPackageInventory.slice';

enum TripLegPackageEventType {
  TripLegPackageOffered = 'TripLegPackageOffered',
  TripLegPackageAccepted = 'TripLegPackageAccepted',
  TripLegPackageRejected = 'TripLegPackageRejected',
  TripLegPackageOfferingsTimerExpired = 'TripLegPackageOfferingsTimerExpired',
  TripLegPackageTimedOut = 'TripLegPackageTimedOut',
}

/**
 * Method for handling all TripLegPackage Events
 * @param sessionInfo The webSocketService sessionInfo object. Contains data copied over from the Redux store as needed
 * @param dispatch The Redux store dispatch function
 * @param detailType A string representing the type of event. Must be one of the TripLegPackageEventType enum values
 * @param detail An object containing the event data, in this case a TripLegPackage
 */
const updateTripLegPackage = (
  sessionInfo: WebSocketSessionInfo,
  dispatch: AppDispatch,
  detailType: string,
  detail: TripLegPackageDetail,
) => {
  // Branch based on specific event type
  switch (detailType) {
    case TripLegPackageEventType.TripLegPackageOffered:
      if (
        detail.transportationProviderID ===
        sessionInfo.loggedInTransportationProviderID
      ) {
        dispatch(tripPackageInventorySlice.addPackage(detail));
      }
      break;
    case TripLegPackageEventType.TripLegPackageAccepted:
    case TripLegPackageEventType.TripLegPackageRejected:
    case TripLegPackageEventType.TripLegPackageOfferingsTimerExpired:
    case TripLegPackageEventType.TripLegPackageTimedOut:
      dispatch(tripPackageInventorySlice.removePackage(detail.packageUUID));
      break;
    default:
      break;
  }
};

export { TripLegPackageEventType, updateTripLegPackage };
